export default __webpack_public_path__ + "static/media/ISEO CLASS-8 EXAM PATTERN 2026-27.8e0926bf.pdf";